export default class TabsLinkImage {

    constructor() {
        this.addEvents();

        if($('body').find('.tabs-link-image').length > 0) {
            this.checkMobileView();
            this.handleResize();
        }

        this.tabsSwiperInstance = null;
    }

    addEvents() {
        $( document ).ready(function() {
            const swiperInstance = document.querySelector('.tabs-link-image .tabs-link-image__list.slider')?.swiper;
            let tabClick = false;

            $('.tabs-link-image .tabs-link-image__tab').off('click').on('click', function (e) {

                e.preventDefault();

                if ($(this).hasClass('active')) return;

                $('.tabs-link-image .tabs-link-image__tab, .tabs-link-image .tabs-link-image__item').removeClass('active');

                $(this).addClass('active');
                const tabIndex = $(this).index() + 1;

                $('.tabs-link-image__item:nth-child(' + tabIndex + ')').addClass('active');

                let slideIndex = $(this).parents('.swiper-slide').length > 0
                    ? $(this).parents('.swiper-slide').data('swiper-slide-index')
                    : $('.tabs-link-image__tab.active').index();

                if (swiperInstance && slideIndex + 4 !== swiperInstance.activeIndex) {
                    tabClick = true;
                    swiperInstance.slideTo(slideIndex);

                    setTimeout(() => {
                        tabClick = false;
                    }, 100);
                }
            });

            if (swiperInstance) {
                swiperInstance.off('slideChange').on('slideChange', function () {
                    let activeIndex = swiperInstance.activeIndex;
                    const slider = document.querySelector('.tabs-link-image .tabs-link-image__tabs')

                    if(slider) {
                        const tabsSwiper = document.querySelector('.tabs-link-image .tabs-link-image__tabs')?.swiper;

                        if (tabsSwiper && !tabClick) {
                            tabsSwiper.slideTo(activeIndex - 3);
                        }
                    }

                    if(!tabClick){
                        $('.tabs-link-image .tabs-link-image__tab').removeClass('active');
                        $('.tabs-link-image .swiper-slide-active .tabs-link-image__tab').addClass('active');
                    }

                    tabClick = false;
                });
            }

        })
    }

    checkMobileView() {
        if ($(window).width() <= 767) {
            this.activateSwiper();
        } else {
            this.deactivateSwiper();
        }
    }

    handleResize() {
        $(window).on('resize', () => {
            this.checkMobileView();
        });
    }

    activateSwiper() {
        if (!this.tabsSwiperInstance) {
            const slider = this.prepareSlider();
            $('.tabs-link-image .tabs-link-image__tab').addClass('slider');

            this.tabsSwiperInstance = new Swiper(slider, {
                direction: 'horizontal',
                slidesPerView: 1,
                speed: 500,
                spaceBetween: 10,
                loop: true,
                on: {
                    init: () => {
                        $(slider).addClass('swiper-initialized swiper-horizontal swiper-pointer-events has-multiple-slides has-transition-slide small-gutters');
                        this.addEvents();
                    },
                },
            });

        }
    }

    deactivateSwiper() {
        if (this.tabsSwiperInstance) {

            this.tabsSwiperInstance = null;

            const slider = document.querySelector('.tabs-link-image .tabs-link-image__tabs');

            if(!slider) return;

            slider.swiper = null;

            $(slider).removeClass('swiper-initialized swiper-horizontal swiper-pointer-events has-multiple-slides has-transition-slide small-gutters');

            $('.tabs-link-image__tab.slider').each(function() {

                $(this).removeClass('slider')
                let clonedTab = '';
                if ($(this).parent().hasClass('swiper-slide')) {

                    if(!$(this).parent().hasClass('swiper-slide-duplicate')){
                        clonedTab = $(this).detach();
                    }

                    if(clonedTab && clonedTab.hasClass('tabs-link-image__tab')){
                        $('.tabs-link-image__tabs .slides.swiper-wrapper').append(clonedTab);
                    }

                }
            });

            if($('.tabs-link-image__tabs .swiper-wrapper').find('.swiper-slide').length > 0) {
                $('.tabs-link-image__tabs .swiper-wrapper').find('.tabs-link-image__tab:first-of-type').addClass('active')
                $('.tabs-link-image__tabs .slides.swiper-wrapper').find('.swiper-slide').each(function () {
                    $(this).remove();
                });
            }

        }
    }

    prepareSlider() {
        const slider = document.querySelector('.tabs-link-image .tabs-link-image__tabs');

        if(!slider) return ;

        const slideWrapper = slider.querySelector('.tabs-link-image__tabs .slides');
        const slides = Array.from(slideWrapper.children);

        slideWrapper.classList.add('swiper-wrapper');

        slides.forEach(s => {
            const sSlide = document.createElement('div');
            sSlide.classList.add('swiper-slide');
            s.parentNode.insertBefore(sSlide, s);
            sSlide.appendChild(s);
        });

        return slider;
    }

}